(function (appComponents) {

	appComponents.services.customerRating = function (Components) {

		var customerRating = {};

		customerRating.name = "customerRating";


		Components.getComponentPrototype().extend(customerRating);

		customerRating._modals = customerRating._getService("modals");

		customerRating.elements = {
			get customerRatingModal() {
				return $("[pc-container='customer-rating--modal']");
			},

			get starImg() {
				return $("[pc-container='customer-rating--star-img']");
			},

			get commentArea() {
				return $("[pc-container='customer-rating--comment-area']");
			},
		};

		customerRating.bindings = function () {
			customerRating._elements.body.on("click", "[pc-container='customer-rating--star-img']", function () {
				var ratingValue = $(this).attr("pc-value");
				customerRating.handlers.onStarImgClick(parseInt(ratingValue));
			});
			customerRating._elements.body.on("click", "[pc-container='customer-rating--confirm-btn']", function () {
				customerRating.handlers.onConfirmClick();
			});

		};

		customerRating.resetRating = function () {
			customerRating.ratingValue = null;
			customerRating.elements.starImg.removeClass("active");
			customerRating.elements.commentArea.val("");
		};

		customerRating.showRatingModal = function () {
			customerRating.resetRating();
			customerRating.elements.customerRatingModal.modal("show");
		};

		customerRating.handlers = {
			onConfirmClick: function () {
				if (!customerRating.ratingValue) {
					customerRating._modals.warning.show(customerRating._messages.customerRating.noStarSelected);
					return;
				}

				var comment = customerRating.elements.commentArea.val();

				var objToSend = {
					rating: customerRating.ratingValue,
					ratingComment: comment
				};

				customerRating._api.customerRating.saveOrderRating(objToSend).then(function (res) {
					if (res && res.status == 200) {

						customerRating.elements.customerRatingModal.modal("hide");

						customerRating.resetRating();

						customerRating._modals.success.show(customerRating._messages.feedbackSuccess);
					} else {
						customerRating._modals.error.show(res.message);
					}
				});
			},
			onStarImgClick: function (ratingValue) {
				customerRating.ratingValue = ratingValue;

				customerRating.elements.starImg.removeClass("active");
				for (var i = 0; i <= ratingValue - 1; i++) {
					customerRating.elements.starImg.eq(i).addClass("active");
				}

			}
		};

		customerRating.init = function () {
			customerRating._bindings();
		};

		return customerRating;


	};

	window.appComponents = appComponents;

})(window.appComponents || {});